<div class="queue-area h-30" [ngClass]="dynamicClasses ? getQueueAreaCssClasses() : {}">
    <div class="queue-item" *ngFor="let item of uploader?.queue" data-uit="upload-item" [ngClass]="{ done: item?.progress == 100 }">
        <ca-file-upload-progress
            [file]="item"
            [uploadProgress]="item.progress"
            (cancelFileUpload)="cancelFileUpload.emit($event)"
            (progressChanged)="progressChanged.emit()"
        ></ca-file-upload-progress>
    </div>
</div>
